import React from 'react';
import { View } from 'react-native';
import Svg, { ClipPath, G, Defs, Path, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const Letter = ({
  color = colors.primary,
  isInverted = true,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
          <g clipPath="url(#clip0_3149_29942)">
            <path
              d="M2 18H5M12 18H19M4.9 13H11.8M8.2 4.3L14 18M3 18L9 2H11L18 18"
              stroke={isInverted ? 'white' : color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3149_29942">
              <rect
                width={size}
                height={size}
                fill={isInverted ? color : 'white'}
              />
            </clipPath>
          </defs>
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      style={style}
      {...props}
    >
      <G clipPath="url(#clip0_3149_29942)">
        <Path
          d="M2 18H5M12 18H19M4.9 13H11.8M8.2 4.3L14 18M3 18L9 2H11L18 18"
          stroke={isInverted ? 'white' : color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3149_29942">
          <Rect
            width={size}
            height={size}
            fill={isInverted ? color : 'white'}
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
